export default __webpack_public_path__ + "static/media/20s_level_won.7fefad3a.mp3";